import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { AppContext } from "../../context/AppContext";
import EditCategory from "./EditCategory";
import "./assets/css/addcategory.css";

const AddCategory = () => {
  const adminurl = "https://htmlgames4u.com/api"; // Example: 'http://localhost:3001/api' or leave blank if same origin
  const [name, setName] = useState("");
  const [categoryType, setCategoryType] = useState("");
  const [status, setStatus] = useState("");
  const [thumbnail, setThumbnail] = useState(null);
  const [preview, setPreview] = useState(null);
  const [image_path, setimage_path] = useState("");
  const [uploadImgMsg, setUploadImgMsg] = useState("");
  const { baseUrl, token } = useContext(AppContext);
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState([]);
  const [editCategoryId, seteditCategoryId] = useState(null);
  const [metatag, setMetaTag] = useState(null);
  const [meta_title, setMetaTitle] = useState();
  const [meta_keyword, setMetaKeyword] = useState("");
  const [meta_description, setMetaDescription] = useState("");
  const [openAddCategory, setAddCategory] = useState(false);
  const [weight, setWeight] = useState(null);
  useEffect(() => {
    handleGetCategory();
  }, []);

  const handleGetCategory = async () => {
    try {
      const response = await axios.get(`${adminurl}/get-category`);
      if (response) {
        setCategory(response.data.data);
      }
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    
    const thmbnaiimg_path = `/category_thumbnail/${file.name}`;
    setimage_path(thmbnaiimg_path);
    setThumbnail(file);
    setPreview(URL.createObjectURL(file)); // show preview
  };

  const handleThumbUpload = async (e) => {
    if (!thumbnail) {
      alert("Please select a file first!");
      return;
    }
    e.preventDefault();
    const formData = new FormData();
    formData.append("thumbnail", thumbnail);

    try {
      const res = await axios.post(
        `${baseUrl}/upload-category-thumbnail`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res) {
        setUploadImgMsg("Thumbnail Img upload successfully");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !categoryType) {
      setStatus("Both fields are required.");
      return;
    }

    try {
      const response = await axios.post(
        `${adminurl}/save-category`,
        {
          name,
          categoryType,
          description,
          image_path,
          metatag,
          meta_title,
          meta_keyword,
          meta_description,
          weight,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        
        setStatus("Category saved successfully!");
        setName("");
        handleGetCategory();
        setCategoryType("");
      } else {
        setStatus(response.data.message || "Failed to save category.");
      }
    } catch (error) {
      console.error("Error saving category:", error);
      setStatus("An error occurred while saving the category.");
    }
  };

  return (
    <div
      // style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      className="container"
    >
      {/* <h2>Add Category</h2> */}
      <div className="caegory_main">
        <h1 className="heading">Add Category</h1>
        <button
          onClick={() => {
            setAddCategory((prev) => !prev);
          }}
        >
          Add New Category
        </button>
      </div>
      {openAddCategory && (
        <div className="add_category_main">
          <div className="category_main_model">
            <form
              onSubmit={handleSubmit}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
              }}
            >
              <div className="form_field">
                <label>Category Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="form-control"
                />
              </div>

              <div className="form_field">
                <label>Category Type</label>
                <input
                  type="text"
                  value={categoryType}
                  onChange={(e) => setCategoryType(e.target.value)}
                  required
                  className="form-control"
                />
              </div>
              <div className="form_field">
                <label>weight</label>
                <input
                  type="text"
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                  required
                  className="form-control"
                />
              </div>

              <div className="form_description">
                <label>
                  Description
                  <textarea
                    name="description"
                    onBlur={(e) => setDescription(e.target.value)}
                    rows="4"
                    cols="25"
                    placeholder="Enter your text here..."
                  ></textarea>
                </label>

                <label>
                  Upload Thumbnail
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                </label>
                <div>
                  <label style={{ marginBottom: "3px" }}>
                    Thumbnail path:
                    <span style={{ color: "red" }}>/var/www/html/</span>{" "}
                  </label>
                  <input type="text" name="image_path" value={image_path} />
                </div>
                {preview && (
                  <img
                    src={preview}
                    alt="Thumbnail Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                    }}
                  />
                )}

                <button onClick={handleThumbUpload}>Upload</button>
                <p style={{ color: "green" }}>{uploadImgMsg}</p>
              </div>

              <div className="form_field">
                <label>Meta Title</label>
                <input
                  type="text"
                  value={meta_title}
                  onChange={(e) => setMetaTitle(e.target.value)}
                  required
                  className="form-control"
                />
              </div>

              <div className="form_field">
                <label>Meta Keyword</label>
                <input
                  type="text"
                  value={meta_keyword}
                  onChange={(e) => setMetaKeyword(e.target.value)}
                  required
                  className="form-control"
                />
              </div>

              <div className="form_field">
                <label>Meta Description</label>
                <textarea
                  value={meta_description}
                  onChange={(e) => setMetaDescription(e.target.value)}
                  rows="3"
                  cols="40"
                  placeholder="Enter SEO meta tags..."
                  className="form-control"
                />
              </div>

              <div class="form_btn">
                <button type="submit" className="btn btn-primary">
                  Save Category
                </button>

                {status && (
                  <div style={{ marginTop: "10px", color: "green" }}>
                    {status}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      )}
      {/* game list */}
      <div className="category_list">
        <h2>Category List</h2>
        <div className="table_main">
          <table
            className="table table-bordered"
            style={{
              width: "100%",
              textAlign: "center",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr
                style={{ backgroundColor: "#f2f2f2", border: "1px solid #ddd" }}
              >
                <th>ID</th>
                <th>Game Name</th>
                <th>Category Type </th>
                <th>Weight </th>
                <th>Image Path</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {category &&
                category.map((game, index) => (
                  <tr
                    key={index}
                    style={{
                      border: "1px solid #ddd",
                      textAlign: "center",
                    }}
                  >
                    <td>{game.id}</td>
                    <td>{game.name}</td>
                    <td>{game.categoryType}</td>
                    <td>{game.weight}</td>
                    <td>{game.image_path}</td>
                    <td>
                      <button
                        onClick={() => seteditCategoryId(game.id)}
                        className="edit"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(game.id)}
                        className="delete"
                      >
                        Delete
                      </button>
                    </td>
                    {/* <td>Add action buttons here if needed</td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* end game list */}
      {editCategoryId && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <EditCategory
            categoryId={editCategoryId}
            onClose={() => seteditCategoryId(null)}
            onUpdated={handleGetCategory}
          />
        </div>
      )}
    </div>
  );
};

export default AddCategory;
